
import { Module } from "./Module";

export class Data extends Module{

  public _extraData: any;

  init() {     
    if (this.data.objectdata){
      try{
        this._extraData = JSON.parse(this.data.objectdata);        
      }catch(e){
        console.warn('DATA - ERROR parsing extra Data',e)
      }
    }
  }

  refresh(){

  }
}
